/* Tłowe wideo homepage: bez kontrolek, klik = pauza/wznów, ikona play widoczna w pauzie (1:1 z prod). */
(function () {
  function initVideo(video) {
    if (video.dataset.bgToggleInit) return;
    video.dataset.bgToggleInit = '1';

    var wrap = video.parentElement;
    if (!wrap) return;
    if (getComputedStyle(wrap).position === 'static') {
      wrap.style.position = 'relative';
    }
    video.style.cursor = 'pointer';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bg-video-toggle';
    btn.setAttribute('aria-label', 'Odtwórz lub wstrzymaj wideo');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
    wrap.appendChild(btn);

    function sync() {
      wrap.classList.toggle('bg-video--paused', video.paused);
    }
    function toggle() {
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        video.pause();
      }
    }
    video.addEventListener('click', toggle);
    btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  }

  function init() {
    var sel = '.home-hero__media video, .promo-banner__media video, .fabric__media video, .insta__cell--left video, .feat-carousel__deco--rt video';
    document.querySelectorAll(sel).forEach(initVideo);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
